<app-header></app-header>

<div class="max-w-2xl mx-auto px-4 py-8 flex flex-col gap-8">

  <h1 class="text-xl font-bold text-gray-800 dark:text-gray-100">Configurações de Produtividade</h1>

  <div *ngIf="isLoading" class="flex justify-center py-8">
    <div class="w-7 h-7 border-4 border-purple-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <div *ngIf="loadError" class="text-sm text-red-700 dark:text-red-400 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg px-4 py-3">
    {{ loadError }}
  </div>

  <!-- Timer do operador -->
  <section *ngIf="!isLoading && !loadError" class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl shadow-sm p-6 flex flex-col gap-5">
    <h2 class="font-semibold text-gray-700 dark:text-gray-200">⏱ Timer de Chamada</h2>

    <div class="grid grid-cols-2 gap-6">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Segundos para chamar</label>
        <input type="number" min="3" max="60" [(ngModel)]="timer.timerSeconds"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
        <span class="text-xs text-gray-400">Contagem regressiva após login ou finalização (padrão: 5s)</span>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Auto-pausa por inatividade (min)</label>
        <input type="number" min="1" max="60" [(ngModel)]="timer.autoPauseMinutes"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
        <span class="text-xs text-gray-400">Pausa automática se não houver interação (padrão: 10 min)</span>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <button (click)="saveTimer()"
        class="px-5 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 font-medium transition-colors">
        Salvar configuração
      </button>
      <span *ngIf="savedTimer" class="text-sm text-green-600 font-medium">✓ Salvo!</span>
    </div>
  </section>

  <!-- Metas -->
  <section *ngIf="!isLoading && !loadError" class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl shadow-sm p-6 flex flex-col gap-5">
    <h2 class="font-semibold text-gray-700 dark:text-gray-200">🎯 Metas de Atendimento</h2>

    <div class="grid grid-cols-3 gap-4">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Meta diária</label>
        <input type="number" min="1" [(ngModel)]="meta.dailyTarget"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
        <span class="text-xs text-gray-400">atendimentos/dia</span>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Meta por hora</label>
        <input type="number" min="1" [(ngModel)]="meta.hourlyTarget"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
        <span class="text-xs text-gray-400">atendimentos/hora</span>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Tempo máx. atendimento</label>
        <input type="number" min="1" [(ngModel)]="meta.maxAttendanceMinutes"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
        <span class="text-xs text-gray-400">minutos</span>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <button (click)="saveMeta()"
        class="px-5 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 font-medium transition-colors">
        Salvar metas
      </button>
      <span *ngIf="savedMeta" class="text-sm text-green-600 font-medium">✓ Salvo!</span>
    </div>
  </section>

  <!-- Priorizar -->
  <section *ngIf="!isLoading && !loadError" class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl shadow-sm p-6 flex flex-col gap-5">
    <h2 class="font-semibold text-gray-700 dark:text-gray-200">⚡ Priorizar — guichê liberado por horário</h2>
    <span class="text-xs text-gray-400 -mt-3">O guichê selecionado vê o botão Priorizar apenas dentro da faixa de horário.</span>

    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Guichê liberado</label>
      <select [(ngModel)]="timer.nrSeqComputadorPriorizar"
        class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600">
        <option [ngValue]="null">Nenhum</option>
        <option *ngFor="let g of guiches" [ngValue]="g.id">{{ g.name }}</option>
      </select>
    </div>

    <div class="grid grid-cols-2 gap-6">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Início</label>
        <input type="time" [(ngModel)]="timer.hrInicioPriorizar"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
      </div>

      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-600 dark:text-gray-300">Fim</label>
        <input type="time" [(ngModel)]="timer.hrFimPriorizar"
          class="border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <button (click)="savePriorizar()"
        class="px-5 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 font-medium transition-colors">
        Salvar
      </button>
      <span *ngIf="savedPriorizar" class="text-sm text-green-600 font-medium">✓ Salvo!</span>
    </div>
  </section>

  <!-- Particular por nivel -->
  <section *ngIf="!isLoading && !loadError" class="bg-white dark:bg-zinc-800 border dark:border-zinc-700 rounded-xl shadow-sm p-6 flex flex-col gap-5">
    <h2 class="font-semibold text-gray-700 dark:text-gray-200">💰 Particular — quem pega primeiro</h2>
    <span class="text-xs text-gray-400 -mt-3">
      Quando houver senha particular esperando, ela é oferecida ao nível 1. Se ele estiver ocupado,
      pausado ou fora, passa ao nível 2, e assim por diante.
    </span>

    <div *ngIf="!novaOrdem" class="text-sm text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/20 rounded-lg px-4 py-3">
      Esta unidade ainda usa a ordem clássica da fila — a preferência por nível não se aplica aqui.
    </div>

    <ng-container *ngIf="novaOrdem">
      <p *ngIf="niveisParticular.length === 0" class="text-sm text-gray-500 dark:text-gray-400">
        Nenhum nível configurado — as senhas particulares seguem a ordem normal da fila.
      </p>

      <div *ngFor="let nivel of niveisParticular; let i = index; trackBy: trackByIndex" class="flex items-center gap-3">
        <span class="text-sm font-medium text-gray-600 dark:text-gray-300 w-16">Nível {{ i + 1 }}</span>

        <div class="flex flex-col flex-1 gap-1">
          <input type="text" [(ngModel)]="niveisParticular[i]" list="operadores-lista"
            placeholder="login do operador"
            class="border rounded-lg px-3 py-2 text-sm uppercase focus:ring-2 focus:ring-purple-400 focus:outline-none dark:bg-zinc-700 dark:border-zinc-600"/>
          <span *ngIf="nivelDesconhecido(niveisParticular[i])" class="text-xs text-amber-600 dark:text-amber-400">
            Sem atendimento em guichê nesta unidade nos últimos 90 dias — confira o login.
          </span>
        </div>

        <button type="button" (click)="subirNivel(i)" [disabled]="i === 0" title="Subir"
          class="px-2 py-1 text-gray-500 hover:text-purple-600 disabled:opacity-30">↑</button>
        <button type="button" (click)="descerNivel(i)" [disabled]="i === niveisParticular.length - 1" title="Descer"
          class="px-2 py-1 text-gray-500 hover:text-purple-600 disabled:opacity-30">↓</button>
        <button type="button" (click)="removeNivel(i)" title="Remover"
          class="px-2 py-1 text-gray-500 hover:text-red-600">✕</button>
      </div>

      <datalist id="operadores-lista">
        <option *ngFor="let op of operadores" [value]="op"></option>
      </datalist>

      <button type="button" (click)="addNivel()"
        class="self-start text-sm text-purple-600 hover:text-purple-700 font-medium">
        + Adicionar nível
      </button>

      <p *ngIf="erroParticular" class="text-sm text-red-600">{{ erroParticular }}</p>

      <div class="flex items-center gap-3">
        <button (click)="saveParticular()" [disabled]="isSubmittingParticular"
          class="px-5 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 font-medium transition-colors disabled:opacity-50">
          Salvar
        </button>
        <span *ngIf="savedParticular" class="text-sm text-green-600 font-medium">✓ Salvo!</span>
      </div>
    </ng-container>
  </section>

</div>
